import React from 'react';

/**
 * Safely extract a human-readable error message from API error responses.
 * Handles both string and object `detail` fields.
 */
export function extractErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (detail && typeof detail === 'object') return detail.message || fallback;
  return err?.message || fallback;
}

/**
 * Global ErrorBoundary to prevent white-screen crashes.
 * Catches React render errors and shows a recovery UI instead.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.warn('[ErrorBoundary] Caught render error:', error?.message, info?.componentStack?.slice(0, 200));
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          minHeight: '300px', padding: '40px', textAlign: 'center',
          background: '#0a0a0a', borderRadius: '16px', margin: '20px',
          border: '1px solid rgba(255,68,68,0.1)',
        }}>
          <p style={{ color: '#ff6b6b', fontSize: '14px', fontWeight: 600, marginBottom: '8px' }}>
            Something went wrong rendering this section.
          </p>
          <p style={{ color: 'rgba(245,240,232,0.35)', fontSize: '13px', marginBottom: '20px' }}>
            {this.state.error?.message?.slice(0, 120) || 'An unexpected error occurred.'}
          </p>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              padding: '10px 24px', borderRadius: '10px', fontSize: '13px', fontWeight: 600,
              background: 'rgba(255,255,255,0.06)', color: '#f5f0e8', border: '1px solid rgba(255,255,255,0.1)',
              cursor: 'pointer',
            }}
          >
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
